import {Pipe, PipeTransform} from '@angular/core';
import {Energy} from 'asax-common';

@Pipe({
  name: 'frequencySupportText'
})
export class FrequencySupportTextPipe implements PipeTransform {

  transform(energies: Energy[], ...args: unknown[]): unknown {
    const frequencies = energies.map(energy => [energy.freqMin, energy.freqMax]).flat();
    const freqMin = Math.min(...frequencies).toFixed(2);
    const freqMax = Math.max(...frequencies).toFixed(2);

    return `${freqMin}..${freqMax}GHz`;
  }

}
